import axios from 'axios';

import {setProviderType} from '../store/DictionarySlice';

export const dictionary = (dispatch) => {

    // список типов поставщиков
    const loadProviderType = () => {
        axios.get('/api/v1/dictionary/provider-type')
            .then((genericResponse) => {
                if (genericResponse.error == '') {
                    dispatch(setProviderType(genericResponse.data));
                }
            }).catch(error => {
        });
    };

    return {
        loadProviderType,
    };
};


